import { createApi } from '../createApi';
import * as dummy from '../dummy/reservations';
import * as real from '../api/reservations';

const api = createApi(dummy, real);

export const reservationService = {
  /* 서비스 (유저용) */
  getList: api.getReservations,
  lookup: api.lookupReservation,
  getById: api.getReservationById,
  getReceiptUrl: api.getReservationReceiptUrl,
  create: api.createReservation,
  cancel: api.cancelReservation,
  rebook: api.rebookReservation,
  checkAvailability: api.checkAvailability,

  /* 관리자 */
  adminGetList: api.getAdminReservations,
  adminGetById: api.getAdminReservationById,
  adminUpdateStatus: api.updateAdminReservationStatus,
  adminCreateExtraCharge: api.createAdminExtraCharge,
  adminUpdateMemo: api.updateAdminReservationMemo,
  adminUpdateDriverInfo: api.updateAdminReservationDriverInfo,
  adminUnblock: api.unblockReservation,
  adminUpdateBufferAfter: api.updateAdminReservationBufferAfter,
};
